import { IRoles } from '../models/User'

export function deepcopy<T>(item: T): T {
	return JSON.parse(JSON.stringify(item))
}

export function getUniqueId(): string {
	const stringArr = []
	for (let i = 0; i < 2; i++) {
		const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
		stringArr.push(S4)
	}
 return stringArr.join('-')
}

export function getMonitoringManagementConfiguration(level: string) {
	const managementConfiguration = {
		'48 meses': {
			value: 1,
			month: 48,
			title: 'PREVENTIVO',
			attribute: 'preventive'
		},
		'36 meses': {
			value: 2,
			month: 36,
			title: 'PREDITIVO',
			attribute: 'predictive'
		},
		'12 meses': {
			value: 3,
			month: 12,
			title: 'CORRETIVO',
			attribute: 'corrective'
		},
		'6 meses': {
			value: 4,
			month: 6,
			title: 'INTENSIVO',
			attribute: 'intensive'
		},
		'0 meses': {
			value: 0,
			month: 0,
			title: 'NENHUM',
			attribute: 'nenhum'
		}
	}

	return level && managementConfiguration[level]
}

export function getTreeSpecialCategory(type: string): string {
	const treeSpecialCategory = {
		'Não se aplica': { value: 'NONE'},
		'Protegida': { value: 'PROTECTED'},
		'Ameaçada': { value: 'THREATENED'},
		'Invasora': { value: 'INVASIVE'},
		'Oportunista': { value: 'OPPORTUNIST'}
	}

	return treeSpecialCategory[type].value
}

export function getTreeCategorySpecialWithValue(type: string): string {
	const treeSpecialCategory = {
		NONE: { value: 'Não se aplica'},
		PROTECTED: { value: 'Protegida'},
		THREATENED: { value: 'Ameaçada'},
		INVASIVE: { value: 'Invasora'},
		OPPORTUNIST: { value: 'Oportunista'}
	}

	return treeSpecialCategory[type].value
}

export const rolesArbolink: Array<IRoles> = [
	{
		name: 'Administrador Arbolink',
		value: 'GENERAL_ADMIN'
	},
	{
		name: 'Botânico',
		value: 'BOTANIC'
	}
]

export const rolesCompany: Array<IRoles> = [
	{
		name: 'Administrador',
		value: 'CUSTOMER'
	},
	{
		name: 'Usuário',
		value: 'USER'
	},
	{
		name: 'Inventariante',
		value: 'INVENTOR'
	},
	{
		name: 'Avaliador',
		value: 'EVALUATOR'
	},
	{
		name: 'Operador',
		value: 'OPERATOR'
	}
]

export const getTreeLocationCategoryCode = (categoryTree: string): number => {
	const treeLocationCategory = {
	  'sistema viário': { value: 1 },
	  'parque, praça e jardim público': { value: 2 },
	  'área particular': { value: 3 },
	  'área protegida': { value: 4 }
	}

	if (categoryTree === null) {
		return 1
	}

	if (treeLocationCategory[categoryTree.toLowerCase()]) {
		return treeLocationCategory[categoryTree.toLowerCase()].value
	}

	return 0
}

export const getTreeFormatCode = (format: string): number => {

	const treeFormat = {
		'regular': {value: 1},
		'irregular': {value: 2},
		'eliptica vertical': {value: 3},
		'eliptica horizontal': {value: 4},
		'cônica': {value: 5},
		'palmeira': {value: 6}
	}

	if (format === null) {
		return 1
	}

	if (treeFormat[format.toLowerCase()]) {
		return treeFormat[format.toLowerCase()].value
	}

	return 0
}

export const removeToolTip = () => {
	const tooltip = document.querySelectorAll('.tooltip')

	if (tooltip) {
		Array.from(tooltip).forEach(element => element.parentNode.removeChild(element))
	}
}

export const scrollToConteiner = (conteiner: HTMLElement) => {
	conteiner.scrollIntoView({
		behavior: 'smooth'
	  })
}

export const insertOrRemoveClassInScrollButton = () => {
	const iframeCloseZendesk = document.querySelector('iframe[title="Fechar mensagem"]')
	const scrollUpButton = document.getElementById('scrollUp-button')

	const updateScrollButtonClass = (add: boolean) => {
		if (scrollUpButton) {
			if (add) {
				scrollUpButton.classList.add('up')
			} else {
				scrollUpButton.classList.remove('up')
			}
		}
	}

	const iframeExist: boolean = Boolean(iframeCloseZendesk)

	// Executa a função inicialmente para garantir que a classe do botão de rolagem esteja correta
	updateScrollButtonClass(iframeExist)
}

export const isValidInt4 = (value: number): boolean => {
	const MAX_INT4 = 2147483647
	const MIN_INT4 = -2147483648

	return Number.isInteger(Number(value)) && value <= MAX_INT4 && value >= MIN_INT4
}

export const arrayPartition = (array: Array<string>) => {
	const parts = []

	for (let i = 0; i < array.length; i += 10) {
		const part = array.slice(i, i + 10)
		parts.push(part)
	}

	return parts
}
